import axios from 'axios';
import { endpoints } from '@/api/endpoints.js';
import { baseURL } from '../../../api/environment';

const URL = baseURL;

/**
 * Registra el suscriptor en el sistema
 */
export const sendRegisterSubscriber = async ({ commit, rootState, dispatch }) => {
    try {
        commit('SET_LOADING', true);
        const endpoint = endpoints.checkout.registerSubscriber.endpoint;
        const user = rootState.Users;
        const telefono = user.user_contact.telefono;
        const token = rootState.Token.token.dataObj;
        
        const requestData = {
            "nombre": user.user.firstName,
            "apellido_paterno": user.user.lastName,
            "apellido_materno": user.user.middleName,
            "email": user.user_additional_contact.email,
            "telefono_celular": telefono,
            "contacto": {
                "telefono_contacto": {
                    "numero_telefono": telefono,
                    "tipo": "Celular"
                },
                "nombre": user.user.firstName,
                "apellido_paterno": user.user.lastName,
                "apellido_materno": user.user.middleName,
                "tipo": "Familiar,"
            }
        };
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                ...requestData
            }
        });
        
        if (Object.keys(data.dataObj).length != 0) {
            if (data.dataObj.codigo_respuesta == 222) {
                commit('SET_ERROR_SUBSCRIPTION', data.dataObj.mensaje_respuesta);
                commit('SET_LOADING', false);
            } else {
                commit('SET_SUBSCRIBER_REGISTRATION', data);
                dispatch('sendRegisterProduct');
            }
        } else {
            commit('SET_ERROR_SUBSCRIPTION', data.msg);
        }
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Registra el producto seleccionado
 */
export const sendRegisterProduct = async ({ commit, rootState }) => {
    try {
        commit('SET_LOADING', true);
        const endpoint = endpoints.checkout.registerProduct.endpoint;
        const subscriber = await rootState.Subscription;
        const products = rootState.Products;
        const checkHD = rootState.Subscription.checkHD;

        const token = await rootState.Token.token.dataObj;
        const requestData = {
            "folio": subscriber.subscriber_registration.dataObj.folio,
            "producto": products.selected.erp_id,
            "equipoHD": checkHD
        };
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                ...requestData
            }
        });
        
        commit('SET_PRODUCT_REGISTRATION', data.dataObj);
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    }
};

/**
 * Registra la dirección del suscriptor
 */
export const sendRegisterDirection = async ({ commit, rootState }, params) => {
    try {
        const endpoint = endpoints.checkout.registerAddress.endpoint;
        const token = await rootState.Token.token.dataObj;
        const subscriber = await rootState.Subscription;

        const requestData = {
            "folio": subscriber.subscriber_registration.dataObj.folio,
            "codigo_postal": params.postalCode,
            "calle": (params.calle ? params.calle : ' - '),
            "numero_exterior": params.exterior,
            "numero_interior": params.interior,
            "colonia": params.colonia,
            "clave_colonia": params.ccolonia,
            "municipio": params.municipio,
            "estado": params.ciudad,
            "referencias": (params.reference ? params.reference : ' - '),
            "entre_calle1": null,
            "entre_calle2": null,
            "cer_google": true
        };
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                ...requestData
            }
        });

        if (Object.keys(data.dataObj).length != 0) {
            if (data.dataObj.codigo_respuesta == 222) {
                commit('SET_ERROR_SUBSCRIPTION', data.dataObj.mensaje_respuesta);
                commit('SET_LOADING', false);
            } else {
                commit('SET_USER_DIRECTION', params);
                commit('SET_DIRECTION_REGISTRATION', data);
            }
        } else {
            commit('SET_ERROR_SUBSCRIPTION', data.msg);
        }
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Obtiene detalles del código postal
 */
export const getGeoPostalCodeDetail = async ({ commit, rootState }) => {
    try {
        commit('SET_LOADING', true);
        const endpoint = endpoints.checkout.geoStatesCities.endpoint;
        const token = await rootState.Token.token.dataObj;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                cp: "01010",
                ccolonia: "5"
            }
        });
        
        commit('SET_GEO_POSTAL', data);
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Envía código postal para validación
 */
export const sendPostalCode = async ({ commit, rootState }, postalCode) => {
    try {
        const endpoint = endpoints.checkout.geoStatesCities.endpoint + `/${postalCode}`;
        const token = await rootState.Token.token.dataObj;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'get',
            baseURL: URL,
            headers: {
                'Authorization': token
            },
        });
        
        commit('SET_GEO_ADDRESS', data.dataObj);
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    }
};
